import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { Paragraph } from './Text';

const Container = styled.div<{ $on?: boolean; error?: boolean }>`
	padding: 2px;
	width: 32px;
	height: 16px;
	background: ${(props) => props.theme.colors.lightBlueDark};
	border-radius: 8px;
	box-sizing: border-box;
	cursor: pointer;
	transition: 0.4s cubic-bezier(0, 1, 0, 1) background-color;

	${(props) =>
		props.$on &&
		`
		background: ${props.theme.colors.primary};
	`}

	${(props) =>
		props.error &&
		`
		background: ${props.theme.colors.danger};
	`}
`;

const Indicator = styled.div<{ $on?: boolean }>`
	width: 12px;
	height: 12px;
	border-radius: 6px;
	background: ${(props) => props.theme.colors.white};
	transition: 0.4s cubic-bezier(0, 1, 0, 1) transform;

	${(props) =>
		props.$on &&
		`
		transform: translateX(16px);
	`}
`;

const ClickContainer = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	cursor: pointer;
`;

export function Switch(props: {
	label?: string | ReactNode;
	on: boolean;
	onChange: (on: boolean) => void;
	error?: boolean;
}) {
	if (props.label) {
		return (
			<Flex alignItems="center">
				<Box mr={3} flexShrink={0} flexGrow={0} style={{ position: 'relative' }}>
					<ClickContainer onClick={() => props.onChange(!props.on)} />
					<Container error={props.error} $on={props.on} onClick={() => props.onChange(!props.on)}>
						<Indicator $on={props.on} />
					</Container>
				</Box>
				{typeof props.label === 'string' ? (
					<Paragraph flexGrow={1} flexShrink={1} onClick={() => props.onChange(!props.on)}>
						{props.label}
					</Paragraph>
				) : (
					<>{props.label}</>
				)}
			</Flex>
		);
	}

	return (
		<Box style={{ position: 'relative' }}>
			<ClickContainer onClick={() => props.onChange(!props.on)} />
			<Container $on={props.on} onClick={() => props.onChange(!props.on)}>
				<Indicator $on={props.on} />
			</Container>
		</Box>
	);
}
